// Phase 10 — Subscriptions module hook.

import { useQuery } from '@tanstack/react-query';

interface SubscriptionEntry {
  id: string;
  name: string;
  provider: string;
  amount_cents: number;
  currency: string;
  billing_cycle: string;
  next_billing_date: string | null;
  category: string;
  active: number;
  notes: string;
  created_at: string;
  updated_at: string;
}

export function useSubscriptions() {
  return useQuery<SubscriptionEntry[]>({
    queryKey: ['subscriptions', 'entries'],
    queryFn: async () => {
      const res = await fetch('/api/modules/subscriptions/entries', {
        credentials: 'same-origin',
      });
      if (!res.ok) throw new Error('Failed to load subscriptions');
      return res.json();
    },
    staleTime: 30_000,
  });
}
